import { useUnlayerTemplatesEditorContext } from '@/components/views/UnlayerEmailsView/UnlayerTemplatesShared/UnlayerTemplatesEditorView/UnlayerTemplatesEditorContext';
import {
	Button,
	Dialog,
	DialogActions,
	DialogContent,
	DialogContentText,
	DialogTitle,
} from '@mui/material';
import React from 'react';

const DiscardDialog = () => {
	const { dialogs, patchDialog, handleDiscardConfirm } = useUnlayerTemplatesEditorContext();

	return (
		<Dialog
			open={dialogs.discard.open}
			onClose={() => patchDialog('discard', { open: false })}
			fullWidth
			maxWidth='sm'
		>
			<DialogTitle>Discard Unsaved Changes?</DialogTitle>
			<DialogContent>
				<DialogContentText>
					You have unsaved changes. If you continue, those changes will be lost.
				</DialogContentText>
			</DialogContent>
			<DialogActions>
				<Button onClick={() => patchDialog('discard', { open: false })}>Cancel</Button>
				<Button variant='contained' onClick={handleDiscardConfirm}>
					Discard Changes
				</Button>
			</DialogActions>
		</Dialog>
	);
};
export default DiscardDialog;
